export default __webpack_public_path__ + "static/media/dynamic.d37a2efd.jpg";